import React from 'react';
import NewTrainingViewer from './NewTrainingViewer';

function TrainingViewer() {
    return (
        <NewTrainingViewer
            apiBase="/api/training"
            showStandaloneNotice={false}
        />
    );
}

export default TrainingViewer;
